export const columnDefs = [
  {
    field: 'vendorName',
    headerName: 'Name',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'totalEmployeesHeadCount',
    headerName: 'Total headcount',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'rto',
    headerName: 'RTO',
    filterParams: { hideMenu: true },
    sortParams: { enabled: false },
    cellRenderer: 'customRtoColumn',
  },
  {
    field: 'pocName',
    headerName: 'Contact',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'pocEmail',
    headerName: 'Contact Email',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'pocPhone',
    headerName: 'Phone',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'msaExpiry',
    headerName: 'Contract Expiry',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'onBoardingDate',
    headerName: 'Onboarded On',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'status',
    headerName: 'Status',
    filterParams: { hideMenu: true },
    sortParams: { enabled: false },
  },
];


export const rtoSegments = [
  { key: 'regularPercentage', class: 'segment-left' },
  { key: 'hybridPercentage', class: 'segment-middle' },
  { key: 'partialHybridPercentage', class: 'segment-middle1' },
  { key: 'remotePercentage', class: 'segment-right' },
];
